import React from 'react'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { Menu, MenuPurge, MenuRestore } from '../../../../shared/menu/menu'
import { IconList } from '../../../../shared/icon/icon'
import { useParamsInt } from '../../../../shared/hooks/location'
import { useApiListUserAssessment } from '../../../../api-new/state/assessment'
import { useRouteMatch } from '../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { useRoleSysLogin } from '../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnText } from '../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../shared/error/server-message'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'

export function AssessmentCourseRecycle() {
  const { url } = useRouteMatch()
  const { nodeID } = useParamsInt()

  const apiListUserAssessment = useApiListUserAssessment()

  const roleSysLogin = useRoleSysLogin()

  const [error, failure, setError] = useErrorLine()

  const handleReady = async () => await apiListUserAssessment.get(`deleted/${nodeID}/node`)
  const handleDestroyed = () => apiListUserAssessment.init()

  const handleRestore = async item => {
    setError(null)
    try {
      await apiListUserAssessment.put(`${item.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That assessment result was already removed.'), err)
    }
    await apiListUserAssessment.get(`deleted/${nodeID}/node`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListUserAssessment} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="assessment" sortable filter />
            <ColumnText field="email" sortable filter />
            <ColumnText field="firstName" sortable filter />
            <ColumnText field="lastName" sortable filter />
            <ColumnDateTime field="start" sortable filter />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show={roleSysLogin.accessDelete} />
                  <MenuPurge to={`${url}/purge/${row.id}`} show={roleSysLogin.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
